import { Trophy } from '@phosphor-icons/react';

const Pct = ({ v }) => (
  <div className="flex items-center gap-2 justify-end">
    <div className="w-20 h-2 bg-black/40 rounded overflow-hidden hidden sm:block">
      <div className="h-full bg-current rounded transition-all" style={{ width: `${v}%` }} />
    </div>
    <span>{v}%</span>
  </div>
);

export const LineupByReport = ({ report, title = 'Lineup By Performance' }) => (
  <div className="bg-[#0F3622] border-2 border-[#F9A8D4] rounded-md overflow-x-auto" data-testid="lineup-by-report">
    <div className="px-4 py-3 text-xs font-bold uppercase tracking-wider text-white flex items-center gap-2">
      <Trophy size={18} weight="duotone" className="text-[#F9A8D4]" /> {title}
      <span className="text-white/60 normal-case font-medium ml-1">— who gives quality lineups</span>
    </div>
    <table className="w-full text-sm">
      <thead>
        <tr className="bg-[#143E29] text-[#F9A8D4] text-[10px] uppercase tracking-wider">
          <th className="text-left px-4 py-1.5">Lineup By</th>
          <th className="text-right px-4 py-1.5">Total Lineup</th>
          <th className="text-right px-4 py-1.5">Going</th>
          <th className="text-right px-4 py-1.5">Going %</th>
          <th className="text-right px-4 py-1.5">Selected</th>
          <th className="text-right px-4 py-1.5">Selected %</th>
          <th className="text-right px-4 py-1.5">Not Going</th>
          <th className="text-right px-4 py-1.5">No Resp.</th>
        </tr>
      </thead>
      <tbody>
        {report.length === 0 ? (
          <tr><td colSpan={8} className="px-4 py-4 text-center text-white/70" data-testid="report-empty">No lineups yet</td></tr>
        ) : report.map((r, i) => (
          <tr key={r.lineup_by} className="border-t border-[#143E29] text-white font-bold" data-testid={`report-row-${r.lineup_by}`}>
            <td className="px-4 py-2 flex items-center gap-2">
              {i === 0 && r.going > 0 && <Trophy size={14} weight="fill" className="text-[#FDE047]" />}
              {r.lineup_by}
            </td>
            <td className="px-4 py-2 text-right text-[#93C5FD]">{r.total}</td>
            <td className="px-4 py-2 text-right text-[#4ADE80]">{r.going}</td>
            <td className="px-4 py-2 text-right text-[#4ADE80]"><Pct v={r.going_pct} /></td>
            <td className="px-4 py-2 text-right text-[#A3E635]">{r.selected}</td>
            <td className="px-4 py-2 text-right text-[#A3E635]"><Pct v={r.selected_pct} /></td>
            <td className="px-4 py-2 text-right text-[#F87171]">{r.not_going}</td>
            <td className="px-4 py-2 text-right text-[#FDE047]">{r.no_response}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
